import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ProjectImg from '../assets/images/projectImg.png';

const ProjectItemStyles = styled.div`
  .projectItem__img {
    width: 100%;
    height: 400px;
    border-radius: 12px;
    overflow: hidden;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
    }
  }
  .details-button {
    background-color: darkgrey;
    color: black;
    border-radius: 5px;
    padding: 10px;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 50px;
  }
  .projectItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .projectItem__title {
    font-size: 2.2rem;
  }
  .projectItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
    height: 150px;
  }
  @media only screen and (max-width: 768px) {
    .projectItem__img {
      height: 350px;
    }
  }
`;

export default function ProjectItem({
  id = 1,
  img1 = ProjectImg,
  title = 'Project Name',
  overview = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
}) {
  return (
    <ProjectItemStyles>
      <Link to="/projects" className="projectItem__img">
        <img src={img1} alt="project img" />
      </Link>
      <div className="projectItem__info">
        <Link to="/projects">
          <h3 className="projectItem__title">{title}</h3>
        </Link>
        <p className="projectItem__desc">{overview}</p>
        <Link className="details-button" to={`/projectDetails/${id}`}>
          See Details
        </Link>
      </div>
    </ProjectItemStyles>
  );
}
